import { useCallback, useEffect, useState, useRef } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import Alert from "./components/Alert";
import pragmLogo from "./images/pragm.png";

function App() {
  const [jwtToken, setJwtToken]             = useState("");
  const [alertMessage, setAlertMessage]     = useState("");
  const [alertClassName, setAlertClassName] = useState("d-none");
  const [tickInterval, setTickInterval]     = useState();
  const [servicesOpen, setServicesOpen]     = useState(false);
  const servicesRef = useRef(null);
  const navigate    = useNavigate();
  const location    = useLocation();
  const isHome      = location.pathname === "/";

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (servicesRef.current && !servicesRef.current.contains(e.target)) {
        setServicesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logOut = () => {
    const requestOptions = {
      method: "GET",
      credentials: "include",
    }
    fetch(`/logout`, requestOptions)
    .catch(error => {
      console.log("error logging out", error);
    })
    .finally(() => {
      setJwtToken("");
      toggleRefresh(false);
    })
    navigate("/login");
  }

  const toggleRefresh = useCallback((status) => {
    console.log("clicked");
    if (status) {
      console.log("turning on ticking");
      let i = setInterval(() => {
        const requestOptions = {
          method: "GET",
          credentials: "include",
        }
        fetch(`/refresh`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.access_token) {
            setJwtToken(data.access_token);
          }
        })
        .catch(error => {
          console.log("user is not logged in");
        })
      }, 600000);
      setTickInterval(i);
      console.log("setting tick interval to", i);
    } else {
      console.log("turning off ticking");
      console.log("turning off tickInterval", tickInterval);
      setTickInterval(null);
      clearInterval(tickInterval);
    }
  }, [tickInterval])

  useEffect(() => {
    if (jwtToken === "") {
      const requestOptions = {
        method: "GET",
        credentials: "include",
      }
      fetch(`/refresh`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.access_token) {
            setJwtToken(data.access_token);
            toggleRefresh(true);
          }
        })
        .catch(error => {
          console.log("user is not logged in", error);
        })
    }
  }, [jwtToken, toggleRefresh])

  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>

      {/* ── NAVBAR ────────────────────────────────────────────────────────────── */}
      <header className="sticky-top" style={{ backgroundColor: "#212121", borderBottom: "2px solid #C0392B" }}>
        <div className="container">
          <div className="d-flex justify-content-between align-items-center" style={{ height: "80px" }}>

            {/* Logo */}
            <Link to="/" className="text-decoration-none">
              <img
                src={pragmLogo}
                alt="ThePragmatic Logo"
                style={{ height: "70px", width: "190px", objectFit: "contain" }}
              />
            </Link>

            {/* Nav central (desktop) */}
            <nav className="d-none d-lg-flex align-items-center gap-4">

              <Link to="/" className="text-decoration-none"
                style={{ color: "#fff", fontWeight: 500, fontSize: "0.95rem" }}
                onMouseEnter={e => e.currentTarget.style.color = "#C0392B"}
                onMouseLeave={e => e.currentTarget.style.color = "#fff"}
              >
                Inicio
              </Link>

              {/* Dropdown Servicios con icono bi-card-list */}
              <div className="position-relative" ref={servicesRef}>
                <button
                  onClick={() => setServicesOpen(prev => !prev)}
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    color: "#fff", fontWeight: 500, fontSize: "0.95rem",
                    display: "flex", alignItems: "center", gap: "6px", padding: 0,
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = "#C0392B"}
                  onMouseLeave={e => e.currentTarget.style.color = "#fff"}
                >
                  <svg width="1.1em" height="1.1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M14.5 3h-13a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                    <path fillRule="evenodd" d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"/>
                    <circle cx="3.5" cy="5.5" r=".5"/><circle cx="3.5" cy="8" r=".5"/><circle cx="3.5" cy="10.5" r=".5"/>
                  </svg>
                  Servicios
                  <svg width="10" height="10" viewBox="0 0 12 12" fill="none"
                    style={{ transform: servicesOpen ? "rotate(180deg)" : "rotate(0)", transition: "transform .2s" }}>
                    <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>

                {servicesOpen && (
                  <div style={{
                    position: "absolute", top: "calc(100% + 10px)", left: 0,
                    minWidth: "260px", background: "#1a1a1a",
                    borderRadius: "8px", boxShadow: "0 8px 30px rgba(0,0,0,.4)",
                    border: "1px solid #333", zIndex: 1000, overflow: "hidden",
                  }}>
                    {[
                      {
                        label: "Controles de Ciberseguridad", to: "/services",
                        icon: (
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M5.443 1.991a60.17 60.17 0 0 0-2.725.802.454.454 0 0 0-.315.366C1.87 7.056 3.1 9.9 4.567 11.773c.736.94 1.533 1.636 2.197 2.093.333.228.626.394.857.5.116.053.21.089.282.11A.73.73 0 0 0 8 14.5c.007-.001.038-.005.097-.023.072-.022.166-.058.282-.111.23-.106.525-.272.857-.5a10.197 10.197 0 0 0 2.197-2.093C12.9 9.9 14.13 7.056 13.597 3.159a.454.454 0 0 0-.315-.366c-.626-.2-1.682-.526-2.725-.802C9.491 1.71 8.51 1.5 8 1.5c-.51 0-1.49.21-2.557.491zm-.256-.966C6.23.749 7.337.5 8 .5c.662 0 1.77.249 2.813.525a61.09 61.09 0 0 1 2.772.815c.528.168.926.623 1.003 1.184.573 4.197-.756 7.307-2.367 9.365a11.191 11.191 0 0 1-2.418 2.3 6.942 6.942 0 0 1-1.007.586c-.27.124-.558.225-.796.225s-.526-.101-.796-.225a6.908 6.908 0 0 1-1.007-.586 11.192 11.192 0 0 1-2.417-2.3C2.167 10.331.839 7.221 1.412 3.024A1.454 1.454 0 0 1 2.415 1.84a61.11 61.11 0 0 1 2.772-.815z"/>
                            <path fillRule="evenodd" d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                          </svg>
                        )
                      },
                      {
                        label: "Hacking Ético de activos", to: "/services",
                        icon: (
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M5.443 1.991a60.17 60.17 0 0 0-2.725.802.454.454 0 0 0-.315.366C1.87 7.056 3.1 9.9 4.567 11.773c.736.94 1.533 1.636 2.197 2.093.333.228.626.394.857.5.116.053.21.089.282.11A.73.73 0 0 0 8 14.5c.007-.001.038-.005.097-.023.072-.022.166-.058.282-.111.23-.106.525-.272.857-.5a10.197 10.197 0 0 0 2.197-2.093C12.9 9.9 14.13 7.056 13.597 3.159a.454.454 0 0 0-.315-.366c-.626-.2-1.682-.526-2.725-.802C9.491 1.71 8.51 1.5 8 1.5c-.51 0-1.49.21-2.557.491zm-.256-.966C6.23.749 7.337.5 8 .5c.662 0 1.77.249 2.813.525a61.09 61.09 0 0 1 2.772.815c.528.168.926.623 1.003 1.184.573 4.197-.756 7.307-2.367 9.365a11.191 11.191 0 0 1-2.418 2.3 6.942 6.942 0 0 1-1.007.586c-.27.124-.558.225-.796.225s-.526-.101-.796-.225a6.908 6.908 0 0 1-1.007-.586 11.192 11.192 0 0 1-2.417-2.3C2.167 10.331.839 7.221 1.412 3.024A1.454 1.454 0 0 1 2.415 1.84a61.11 61.11 0 0 1 2.772-.815z"/>
                            <path d="M8 2.25c.909 0 3.188.685 4.254 1.022a.94.94 0 0 1 .656.773c.814 6.424-4.13 9.452-4.91 9.452V2.25z"/>
                          </svg>
                        )
                      },
                      {
                        label: "Seguridad informática a la medida", to: "/services",
                        icon: (
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M5.443 1.991a60.17 60.17 0 0 0-2.725.802.454.454 0 0 0-.315.366C1.87 7.056 3.1 9.9 4.567 11.773c.736.94 1.533 1.636 2.197 2.093.333.228.626.394.857.5.116.053.21.089.282.11A.73.73 0 0 0 8 14.5c.007-.001.038-.005.097-.023.072-.022.166-.058.282-.111.23-.106.525-.272.857-.5a10.197 10.197 0 0 0 2.197-2.093C12.9 9.9 14.13 7.056 13.597 3.159a.454.454 0 0 0-.315-.366c-.626-.2-1.682-.526-2.725-.802C9.491 1.71 8.51 1.5 8 1.5c-.51 0-1.49.21-2.557.491zm-.256-.966C6.23.749 7.337.5 8 .5c.662 0 1.77.249 2.813.525a61.09 61.09 0 0 1 2.772.815c.528.168.926.623 1.003 1.184.573 4.197-.756 7.307-2.367 9.365a11.191 11.191 0 0 1-2.418 2.3 6.942 6.942 0 0 1-1.007.586c-.27.124-.558.225-.796.225s-.526-.101-.796-.225a6.908 6.908 0 0 1-1.007-.586 11.192 11.192 0 0 1-2.417-2.3C2.167 10.331.839 7.221 1.412 3.024A1.454 1.454 0 0 1 2.415 1.84a61.11 61.11 0 0 1 2.772-.815z"/>
                            <path d="M9.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                            <path d="M7.411 8.034a.5.5 0 0 1 .493-.417h.156a.5.5 0 0 1 .492.414l.347 2a.5.5 0 0 1-.493.585h-.835a.5.5 0 0 1-.493-.582l.333-2z"/>
                          </svg>
                        )
                      },
                      {
                        label: "Desarrollo Web", to: "/services",
                        icon: (
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path fillRule="evenodd" d="M6.854 4.646a.5.5 0 0 1 0 .708L4.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0zm2.292 0a.5.5 0 0 0 0 .708L11.793 8l-2.647 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708 0z"/>
                          </svg>
                        )
                      },
                    ].map((item, idx) => (
                      <Link
                        key={idx}
                        to={item.to}
                        onClick={() => setServicesOpen(false)}
                        style={{
                          display: "flex", alignItems: "center", gap: "10px",
                          padding: "12px 20px", color: "#ccc", textDecoration: "none",
                          fontSize: "0.88rem", transition: "background .15s, color .15s",
                          borderBottom: "1px solid #2a2a2a",
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background="#C0392B"; e.currentTarget.style.color="#fff"; }}
                        onMouseLeave={e => { e.currentTarget.style.background="transparent"; e.currentTarget.style.color="#ccc"; }}
                      >
                        {item.icon} {item.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              {/* Blog con icono bi-newspaper */}
              <a href="https://blog.thepragmatic.xyz/" className="text-decoration-none"
                style={{ color: "#fff", fontWeight: 500, fontSize: "0.95rem", display: "flex", alignItems: "center", gap: "5px" }}
                onMouseEnter={e => e.currentTarget.style.color = "#C0392B"}
                onMouseLeave={e => e.currentTarget.style.color = "#fff"}
              >
                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M0 2A1.5 1.5 0 0 1 1.5.5h11A1.5 1.5 0 0 1 14 2v12a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 14V2zm1.5-.5A.5.5 0 0 0 1 2v12a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5h-11z"/>
                  <path fillRule="evenodd" d="M15.5 3a.5.5 0 0 1 .5.5V14a1.5 1.5 0 0 1-1.5 1.5h-3v-1h3a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 1 .5-.5z"/>
                  <path d="M2 3h10v2H2V3zm0 3h4v3H2V6zm0 4h4v1H2v-1zm0 2h4v1H2v-1zm5-6h2v1H7V6zm3 0h2v1h-2V6zM7 8h2v1H7V8zm3 0h2v1h-2V8zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1z"/>
                </svg>
                Blog
              </a>

              {/* Contáctenos con icono bi-inboxes-fill */}
              <Link to="/contacto" className="text-decoration-none"
                style={{ color: "#fff", fontWeight: 500, fontSize: "0.95rem", display: "flex", alignItems: "center", gap: "5px" }}
                onMouseEnter={e => e.currentTarget.style.color = "#C0392B"}
                onMouseLeave={e => e.currentTarget.style.color = "#fff"}
              >
                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M.125 11.17A.5.5 0 0 1 .5 11H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0 .5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .496.562l-.39 3.124A1.5 1.5 0 0 1 14.117 16H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .121-.393zM3.81.563A1.5 1.5 0 0 1 4.98 0h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1-.78.624l-3.7-4.624A.5.5 0 0 0 11.02 1H4.98a.5.5 0 0 0-.39.188L.89 5.812a.5.5 0 1 1-.78-.624L3.81.563z"/>
                  <path fillRule="evenodd" d="M.125 5.17A.5.5 0 0 1 .5 5H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0A.5.5 0 0 1 10 5h5.5a.5.5 0 0 1 .496.562l-.39 3.124A1.5 1.5 0 0 1 14.117 10H1.883A1.5 1.5 0 0 1 .394 8.686l-.39-3.124a.5.5 0 0 1 .121-.393z"/>
                </svg>
                Contáctenos
              </Link>

            </nav>

            {/* ── Barra de búsqueda + Login — zona derecha ── */}
            <div className="d-none d-lg-flex align-items-center gap-2">
              <input
                type="search"
                placeholder="Search"
                className="form-control form-control-sm"
                style={{ width: "180px", backgroundColor: "#fff", border: "1px solid #ccc" }}
              />
              <button className="btn btn-outline-success btn-sm" type="button">
                Search
              </button>

              {jwtToken === "" ? (
                <Link to="/login"
                  style={{
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                    padding: "8px 20px", borderRadius: "999px",
                    background: "#C0392B", color: "#fff",
                    fontWeight: "600", fontSize: "0.88rem",
                    textDecoration: "none", border: "2px solid #C0392B",
                    transition: "opacity .2s",
                  }}
                  onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                  onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                >
                  Iniciar sesión
                </Link>
              ) : (
                <button onClick={logOut}
                  style={{
                    display: "inline-flex", alignItems: "center",
                    padding: "8px 20px", borderRadius: "999px",
                    background: "none", color: "#C0392B",
                    fontWeight: "600", fontSize: "0.88rem",
                    border: "2px solid #C0392B", cursor: "pointer",
                    transition: "background .2s, color .2s",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background="#C0392B"; e.currentTarget.style.color="#fff"; }}
                  onMouseLeave={e => { e.currentTarget.style.background="none";    e.currentTarget.style.color="#C0392B"; }}
                >
                  Cerrar sesión
                </button>
              )}
            </div>

          </div>
        </div>
      </header>

      {/* ── CONTENIDO PRINCIPAL ──────────────────────────────────────────────── */}
      <div className="container-fluid flex-grow-1 p-0">
        <div className="row g-0">

          {!isHome && (
            <aside className="col-md-2 bg-white border-end d-none d-md-block px-3 py-4"
              style={{ minHeight: "calc(100vh - 80px)" }}>
              <h6 style={{ color: "#999", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase" }}>
                SERVICIOS
              </h6>
              <div className="list-group list-group-flush mb-4">
                <Link to="/services" className="list-group-item list-group-item-action">Servicios</Link>
                <Link to="/blog"     className="list-group-item list-group-item-action">Blog</Link>
              </div>
              {jwtToken !== "" && (
                <>
                  <h6 style={{ color: "#999", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase" }}>
                    ADMINISTRACIÓN
                  </h6>
                  <div className="list-group list-group-flush">
                    <Link to="/graphql" className="list-group-item list-group-item-action">GraphQL</Link>
                  </div>
                </>
              )}
            </aside>
          )}

          <main className={isHome ? "col-12" : "col-md-10 py-4 px-3 px-md-4"}>
            <div className={isHome ? "" : "container-fluid p-0"}>
              <Alert message={alertMessage} className={alertClassName} />
              {isHome ? (
                <Outlet context={{ jwtToken, setJwtToken, setAlertClassName, setAlertMessage, toggleRefresh }} />
              ) : (
                <div className="bg-white rounded-4 shadow-sm p-4" style={{ width: "100%", minHeight: "78vh" }}>
                  <Outlet context={{ jwtToken, setJwtToken, setAlertClassName, setAlertMessage, toggleRefresh }} />
                </div>
              )}
            </div>
          </main>

        </div>
      </div>

      {/* ── FOOTER ───────────────────────────────────────────────────────────── */}
      <footer className="py-5 mt-auto" style={{ backgroundColor: "#212121", color: "#ffffff", borderTop: "3px solid #C0392B" }}>
        <div className="container">
          <div className="row justify-content-center mb-4">
            <div className="col-auto">
              <img src={pragmLogo} alt="ThePragmatic" style={{ height: "70px", width: "190px", objectFit: "contain" }} />
            </div>
          </div>
          <div className="row g-4">

            {/* Dirección */}
            <div className="col-md-4 text-center text-md-start">
              <h5 style={{ color: "#fff", fontWeight: 700, marginBottom: "12px" }}>Dirección</h5>
              <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.85rem", margin: "4px 0" }}>Calle 39 sur # 34 - 118 801</p>
              <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.85rem", margin: "4px 0" }}>team@thepragmatic.xyz</p>
              <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.85rem", margin: "4px 0" }}>Tel: (+57) (4) 3790999</p>
              <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.85rem", margin: "4px 0" }}>Envigado - Antioquia</p>
            </div>

            {/* Redes sociales — iconos Font Awesome del original */}
            <div className="col-md-4 text-center">
              <h5 style={{ color: "#fff", fontWeight: 700, marginBottom: "12px" }}>Redes Sociales</h5>
              <div className="d-flex justify-content-center gap-3">
                <a href="https://facebook.com" target="_blank" rel="noreferrer"
                  style={{ color: "rgba(255,255,255,0.7)", textDecoration: "none", transition: "color .2s" }}
                  onMouseEnter={e => e.currentTarget.style.color = "#C0392B"}
                  onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}
                >
                  <i className="icon-facebook-sign"></i>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer"
                  style={{ color: "rgba(255,255,255,0.7)", textDecoration: "none", transition: "color .2s" }}
                  onMouseEnter={e => e.currentTarget.style.color = "#C0392B"}
                  onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}
                >
                  <i className="icon-instagram"></i>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noreferrer"
                  style={{ color: "rgba(255,255,255,0.7)", textDecoration: "none", transition: "color .2s" }}
                  onMouseEnter={e => e.currentTarget.style.color = "#C0392B"}
                  onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}
                >
                  <i className="icon-twitter-sign"></i>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noreferrer"
                  style={{ color: "rgba(255,255,255,0.7)", textDecoration: "none", transition: "color .2s" }}
                  onMouseEnter={e => e.currentTarget.style.color = "#C0392B"}
                  onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}
                >
                  <i className="icon-youtube"></i>
                </a>
              </div>
            </div>

            {/* Transformación digital */}
            <div className="col-md-4 text-center text-md-end">
              <h5 style={{ color: "#fff", fontWeight: 700, marginBottom: "8px" }}>Transformación digital</h5>
              <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.85rem", margin: 0 }}>
                En función de la protección de sus activos.
              </p>
            </div>

          </div>

          {/* Copyright */}
          <div style={{ borderTop: "1px solid #333", marginTop: "32px", paddingTop: "16px", textAlign: "center" }}>
            <p style={{ margin: 0, fontSize: "0.78rem", color: "rgba(255,255,255,0.4)" }}>
              © 2025 Copyright ThePragmatic.xyz
            </p>
          </div>
        </div>
      </footer>

    </div>
  );
}

export default App;